import Lang from '/@/modules/core/app/services/Lang';
import Enum from '/@/modules/core/app/helpers/Enum';
import { EstateProductType } from '@/modules/estate/enums/EstateProductType';
import { HubSpotMeetingLinkTypeKey } from '@/modules/user/constants/HubSpotMeetingLinkTypeKey';

export class HubSpotMeetingLinkType extends Enum {
  key!: HubSpotMeetingLinkTypeKey;
  value!: string;
  category!: string;
  order!: number;

  static KICK_OFF: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.KICK_OFF,
    get value() {
      return Lang.t('user.kick-off-meeting');
    },
    category: EstateProductType.SETTLEMENT.key,
    order: 10
  };

  static PATH_TO_PROBATE: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.PATH_TO_PROBATE,
    get value() {
      return Lang.t('user.probate-determination-meeting');
    },
    category: EstateProductType.SETTLEMENT.key,
    order: 20
  };

  static PROBATE: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.PROBATE,
    get value() {
      return Lang.t('user.probate-preparation-meeting');
    },
    category: EstateProductType.SETTLEMENT.key,
    order: 30
  };

  static INTAKE: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.INTAKE,
    get value() {
      return Lang.t('user.intake-meeting');
    },
    category: EstateProductType.PLANNING.key,
    order: 10
  };

  static GUIDANCE: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.GUIDANCE,
    get value() {
      return Lang.t('user.guidance-meeting');
    },
    category: EstateProductType.PLANNING.key,
    order: 20
  };

  static WILL_REVIEW: HubSpotMeetingLinkType = {
    key: HubSpotMeetingLinkTypeKey.WILL_REVIEW,
    get value() {
      return Lang.t('user.will-review-meeting');
    },
    category: EstateProductType.PLANNING.key,
    order: 30
  };
}
